<template>
  <div class="ovg-page">
    <div class="ovg-page__bg" aria-hidden="true" />

    <header class="ovg-header">
      <div
        class="ovg-header__logos"
        @click="$router.push({ name: 'ovg-landing' })"
      >
        <img
          src="@/assets/logo_original.svg"
          alt="Samtek"
          class="ovg-header__logo-samtek"
        />
        <img
          src="@/assets/logo_asus.png"
          alt="ASUS"
          class="ovg-header__logo-asus"
        />
      </div>
      <button class="ovg-header__salir" @click="volverAlInicio">
        Salir <font-awesome-icon icon="sign-out-alt" />
      </button>
    </header>

    <div class="ovg-subheader">
      <h2 class="ovg-subheader__title">Resultado de tu pago</h2>
      <p class="ovg-subheader__subtitle">
        Aquí puedes ver el estado de tu transacción.
      </p>
    </div>

    <!-- Exitoso / Aprobado -->
    <div v-if="esExitoso" class="ovg-card ovg-card--centrado">
      <font-awesome-icon
        icon="check-circle"
        class="ovg-resultado__icon ovg-resultado__icon--success"
      />
      <h3 class="ovg-resultado__titulo">¡Pago exitoso!</h3>
      <p class="ovg-resultado__texto">
        Tu garantía extendida ha sido activada. Recibirás la confirmación y los
        documentos en tu correo electrónico.
      </p>
      <div class="ovg-info-box">
        <div class="ovg-info-box__row">
          <span class="ovg-info-box__label">Estado</span>
          <span class="ovg-info-box__value ovg-info-box__value--success"
            >Aprobado</span
          >
        </div>
      </div>
      <button
        type="button"
        class="ovg-btn ovg-btn--primary"
        @click="volverAlInicio"
      >
        Volver al inicio
      </button>
    </div>

    <!-- Pendiente -->
    <div v-else-if="esPendiente" class="ovg-card ovg-card--centrado">
      <font-awesome-icon
        icon="info-circle"
        class="ovg-resultado__icon ovg-resultado__icon--info"
      />
      <h3 class="ovg-resultado__titulo">Pago en proceso</h3>
      <p class="ovg-resultado__texto">
        Tu pago está siendo procesado. Te notificaremos por correo electrónico
        cuando se confirme la transacción.
      </p>
      <div class="ovg-info-box">
        <div class="ovg-info-box__row">
          <span class="ovg-info-box__label">Estado</span>
          <span class="ovg-info-box__value ovg-info-box__value--info"
            >Pendiente</span
          >
        </div>
      </div>
      <button
        type="button"
        class="ovg-btn ovg-btn--primary"
        @click="volverAlInicio"
      >
        Volver al inicio
      </button>
    </div>

    <!-- Error boleta -->
    <div v-else-if="esErrorBoleta" class="ovg-card ovg-card--centrado">
      <font-awesome-icon
        icon="exclamation-triangle"
        class="ovg-resultado__icon ovg-resultado__icon--error"
      />
      <h3 class="ovg-resultado__titulo">Error en la boleta</h3>
      <p class="ovg-resultado__texto">
        Ocurrió un problema al procesar la boleta adjunta. Por favor revisa el
        documento e intenta nuevamente.
      </p>
      <div class="ovg-info-box">
        <div class="ovg-info-box__row">
          <span class="ovg-info-box__label">Estado</span>
          <span class="ovg-info-box__value ovg-info-box__value--error"
            >Error en boleta</span
          >
        </div>
      </div>
      <div class="ovg-resultado__acciones">
        <button
          type="button"
          class="ovg-btn ovg-btn--secondary"
          @click="volverAlInicio"
        >
          Volver al inicio
        </button>
        <button
          type="button"
          class="ovg-btn ovg-btn--primary"
          @click="$router.push({ name: 'ovg-modelo' })"
        >
          Reintentar
        </button>
      </div>
    </div>

    <!-- Rechazado / Fallido / Cancelado -->
    <div v-else class="ovg-card ovg-card--centrado">
      <font-awesome-icon
        icon="exclamation-triangle"
        class="ovg-resultado__icon ovg-resultado__icon--warn"
      />
      <h3 class="ovg-resultado__titulo">Pago no completado</h3>
      <p class="ovg-resultado__texto">
        La transacción no pudo completarse. Puedes intentarlo nuevamente o
        contactarnos si necesitas ayuda.
      </p>
      <div class="ovg-info-box">
        <div class="ovg-info-box__row">
          <span class="ovg-info-box__label">Estado</span>
          <span class="ovg-info-box__value ovg-info-box__value--warn">{{
            estadoLabel
          }}</span>
        </div>
      </div>
      <div class="ovg-resultado__acciones">
        <button
          type="button"
          class="ovg-btn ovg-btn--secondary"
          @click="volverAlInicio"
        >
          Volver al inicio
        </button>
        <button
          type="button"
          class="ovg-btn ovg-btn--primary"
          @click="$router.push({ name: 'ovg-catalogo' })"
        >
          Intentar nuevamente
        </button>
      </div>
    </div>

    <!-- Botón de contacto WhatsApp: oculto hasta que el negocio lo habilite
    <a
      href="https://wa.me"
      class="ovg-contact-btn"
      target="_blank"
      rel="noopener"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path :d="waSvgPath" />
      </svg>
    </a>
    -->

    <p class="ovg-page__footer">
      © 2026 Samtek | Servicio Técnico ASUS Autorizado en Chile.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ResultadoPagoView',
  data() {
    return {
      waSvgPath:
        // eslint-disable-next-line max-len
        'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z',
    }
  },
  computed: {
    estado() {
      return (this.$route.query.estado || '').toUpperCase()
    },
    esExitoso() {
      return this.estado === 'EXITOSO' || this.estado === 'APPROVED'
    },
    esPendiente() {
      return this.estado === 'PENDIENTE'
    },
    esErrorBoleta() {
      return this.estado === 'ERROR_BOLETA'
    },
    estadoLabel() {
      const labels = {
        REJECTED: 'Rechazado',
        FAILED: 'Fallido',
        CANCELLED: 'Cancelado',
      }
      return labels[this.estado] || this.estado
    },
  },
  methods: {
    volverAlInicio() {
      this.$router.push({ name: 'ovg-landing' })
    },
  },
}
</script>

<style scoped>
.ovg-page {
  font-family: 'Noto Sans', sans-serif;
  min-height: 100vh;
  background-color: #f5f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 80px;
}

.ovg-page__bg {
  /* Sin `opacity`: el PNG ya es una marca de agua (su patrón viene con
     alpha 13/255). Desvanecerlo otra vez acá lo dejaba en 0,62% de
     contraste, o sea invisible en pantalla. */
  position: fixed;
  inset: 0;
  background-image: url('~@/assets/fondo_samtek.png');
  background-size: cover;
  background-position: center;
  pointer-events: none;
  z-index: 0;
}

.ovg-header {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 55px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 162px;
  flex-shrink: 0;
}

.ovg-header__logos {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.ovg-header__logo-samtek {
  height: 18px;
  width: auto;
}

.ovg-header__logo-asus {
  height: 18px;
  width: auto;
}

.ovg-header__salir {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #23201c;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

.ovg-subheader {
  position: relative;
  z-index: 1;
  width: 100%;
  background: #0a192f;
  min-height: 195px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px 20px;
  text-align: center;
}

.ovg-subheader__title {
  font-size: 28px;
  font-weight: 700;
  color: #f5f6fa;
  margin: 0;
}

.ovg-subheader__subtitle {
  font-size: 15px;
  font-weight: 400;
  color: #f5f6fa;
  margin: 0;
  line-height: 1.5;
}

.ovg-card {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  width: 700px;
  max-width: calc(100% - 40px);
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.25);
  margin-top: -20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ovg-card--centrado {
  align-items: center;
  text-align: center;
}

.ovg-resultado__icon {
  font-size: 74px;
}

.ovg-resultado__icon--success {
  color: #22c55e;
}

.ovg-resultado__icon--info {
  color: #1d4ed8;
}

.ovg-resultado__icon--warn {
  color: #fece2f;
}

.ovg-resultado__icon--error {
  color: #ff3838;
}

.ovg-resultado__titulo {
  font-size: 22px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

.ovg-resultado__texto {
  font-size: 15px;
  color: #525252;
  margin: 0;
  line-height: 1.5;
  max-width: 480px;
}

.ovg-info-box {
  background: #dddde1;
  border: 1px solid #525252;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

.ovg-info-box__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.ovg-info-box__label {
  color: #525252;
  font-weight: 400;
}

.ovg-info-box__value {
  color: #23201c;
  font-weight: 600;
}

.ovg-info-box__value--success {
  color: #22c55e;
}

.ovg-info-box__value--info {
  color: #1d4ed8;
}

.ovg-info-box__value--warn {
  color: #f59e0b;
}

.ovg-info-box__value--error {
  color: #ff3838;
}

.ovg-resultado__acciones {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.ovg-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  padding: 10px 20px;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s;
  white-space: nowrap;
}

.ovg-btn:hover {
  opacity: 0.9;
}

.ovg-btn--primary {
  background: #fece2f;
  color: #23201c;
}

.ovg-btn--secondary {
  background: #f5f6fa;
  color: #23201c;
}

.ovg-contact-btn {
  position: fixed;
  bottom: 90px;
  right: 70px;
  z-index: 10;
  width: 45px;
  height: 45px;
  background: #fece2f;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #23201c;
  font-size: 20px;
  text-decoration: none;
}

.ovg-page__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  font-size: 15px;
  font-weight: 400;
  color: #23201c;
  text-align: center;
  margin: 0;
  padding: 12px 0;
  border-top: 1px solid #d2d2d2;
  background: #f5f6fa;
}

/* ============================================================
   MOBILE — max-width: 767px
   ============================================================ */
@media (max-width: 767px) {
  /* Page */
  .ovg-page {
    padding-bottom: 60px;
  }

  /* Header */
  .ovg-header {
    padding: 0 20px;
  }

  /* Sub-header */
  .ovg-subheader {
    min-height: auto;
    padding: 24px 20px;
  }

  .ovg-subheader__title {
    font-size: 22px;
  }

  .ovg-subheader__subtitle {
    font-size: 14px;
  }

  /* Card */
  .ovg-card {
    width: calc(100% - 32px);
    border-radius: 16px;
  }

  /* Acciones → columna */
  .ovg-resultado__acciones {
    flex-direction: column;
    align-items: stretch;
  }

  .ovg-resultado__acciones .ovg-btn {
    width: 100%;
  }
}
</style>
